/**
 * antd / dayjs locale wiring for the current UI language.
 */

import type { ReactNode } from 'react';
import { ConfigProvider } from 'antd';
import enUS from 'antd/locale/en_US';
import zhCN from 'antd/locale/zh_CN';

import { useLanguageStore, type Lang } from '@/store/languageStore';

export type AntdLocale = typeof zhCN;

export const antdLocaleFor = (lang: Lang): AntdLocale => (lang === 'en' ? enUS : zhCN);

export const dayjsLocaleFor = (lang: Lang): string => (lang === 'en' ? 'en' : 'zh-cn');

let installed = false;

/**
 * Static antd APIs (Modal.confirm, message) render outside the React tree and
 * do not inherit ConfigProvider. Register a holder so their built-in labels
 * follow the selected language.
 */
export const installStaticHolder = (): void => {
  if (installed) return;
  installed = true;

  ConfigProvider.config({
    holderRender: (children: ReactNode) => (
      <ConfigProvider locale={antdLocaleFor(useLanguageStore.getState().lang)}>
        {children}
      </ConfigProvider>
    ),
  });
};
